import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'
import {
    get_org_type, get_org_category, get_jobprovider_profile,
    get_update_profile, get_Sector, getJobProviderAddress
} from '../../../actions/employerAction';
import { get_User_Subistrict, get_User_District, getOngoingSkillCourses, getUpcomingSkillCourses, set_Loader, unset_Loader, getAppliedSkillCourses, setNotification, get_selected_User_District, getSectors, getCourses, getSchemesDataList } from '../../../actions/accountAction';
import store from '../../../store';
import Sidebar from './Sidebar';
import Validation from "../../hoc/Validation";
import SimpleReactValidator from 'simple-react-validator';
import { Link } from 'react-router'
import axios from "axios";

import ServerSetting from "../../../config.json";

class SkillDevlopment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            start_date: '',
            end_date: '',
            course_id: '',
            district_id: '',
            sector_id: '',
            id: '',
            hasFetchedUserData: false, // flag to ensure we call APIs only once
        }
        store.dispatch(getOngoingSkillCourses())
        store.dispatch(get_selected_User_District());
        store.dispatch(getSectors())
        store.dispatch(getSchemesDataList())
        // store.dispatch(getUpcomingSkillCourses({ user_id: this.props.actionReducer.Loginuser.id }))
        // store.dispatch(getAppliedSkillCourses({ user_id: this.props.actionReducer.Loginuser.id, applied_courses: 1, }))

    }






    componentDidMount() {
        document.title = this.props.t('jobProviderProfile.profile', { param: 'react' })

    }
    componentDidUpdate(prevProps, prevState) {
        const userId = this.props.actionReducer?.Loginuser?.id;

        // Only fetch when user ID becomes available and we haven't fetched yet
        if (userId && !this.state.hasFetchedUserData) {
            store.dispatch(getUpcomingSkillCourses({ user_id: userId }));
            store.dispatch(getAppliedSkillCourses({ user_id: userId, applied_courses: 1 }));

            this.setState({ hasFetchedUserData: true }); // prevent re-fetching
        }

    }
    applyForCourse(start_date, end_date, course_id) {

        store.dispatch(set_Loader());
        let environment =
            typeof process.env.NODE_ENV !== "undefined" &&
                process.env.NODE_ENV === "production"
                ? "production"
                : "development";

        let API_SERVER = ServerSetting[environment].API_SERVER;
        const url = `${API_SERVER}` + "skill-courses/apply-course";
        const payload = {
            start_date,
            end_date,
            user_id: this.props.actionReducer.Loginuser.id,
            course_id,

        };

        axios.post(url, payload)
            .then(response => {
                store.dispatch(unset_Loader());
                if (response.data.status === "200") {
                    store.dispatch(getUpcomingSkillCourses({ user_id: this.props.actionReducer.Loginuser.id, course_id: this.state.course_id, sector_id: this.state.sector_id, district_id: this.state.district_id }))
                    store.dispatch(getAppliedSkillCourses({ user_id: this.props.actionReducer.Loginuser.id, applied_courses: 1 }))
                    store.dispatch(setNotification({
                        type: "success",
                        message: response.data.message,
                    }))
                } else {
                    store.dispatch(setNotification({
                        type: "error",
                        message: response.data.message,
                    }))
                }
            })
            .catch(error => {
                store.dispatch(unset_Loader());
                store.dispatch(setNotification({
                    type: "error",
                    message: response.data.message,
                }))
                console.error('Error applying for course:', error);
            });
    }

    async handleUserInput(e, course) {
        const name = e.target.name;
        let value = e.target.value;
        let type = e.target.type;
        let key = e.target.key;

        if (name === "sector_id") {
            store.dispatch(getCourses({ sector_id: value }))
        }

        this.setState({ [name]: value, submitStatus: false });

        if (course === "upcoming") {
            store.dispatch(getUpcomingSkillCourses({ user_id: this.props.actionReducer?.Loginuser?.id, sector_id: name === 'sector_id' ? value : this.state.sector_id, district_id: name === 'district_id' ? value : this.state.district_id, course_id: name === 'course_id' ? value : name === 'sector_id' ? "" : this.state.course_id, shceme_id: name === 'shceme_id' ? value : this.state.shceme_id }))
        } else if (course === "ongoing") {
            store.dispatch(getOngoingSkillCourses({ sector_id: name === 'sector_id' ? value : this.state.sector_id, district_id: name === 'district_id' ? value : this.state.district_id, course_id: name === 'course_id' ? value : this.state.course_id }))
        } else {
            store.dispatch(getAppliedSkillCourses({ user_id: this.props.actionReducer?.Loginuser?.id, sector_id: name === 'sector_id' ? value : this.state.sector_id, district_id: name === 'district_id' ? value : this.state.district_id, course_id: name === 'course_id' ? value : this.state.course_id, applied_courses: 1 }))
        }


    }

    createDistoption = () => {
        let Mainprops = this.props;
        let Distoption = [];
        if (Mainprops.actionReducer.selectedDistricts.length > 0) {
            Mainprops.actionReducer.selectedDistricts.map(function (data) {
                if (data.state_name === "Punjab") {
                    data.dist.map(function (distdata, distindex) {
                        Distoption.push(
                            <option key={distindex} value={distdata.id}>
                                {distdata.name}
                            </option>
                        );
                        return Distoption;
                    });
                }
                return Distoption;
            });
        }
        return Distoption;
    };


    render() {

        if (localStorage.getItem('Islogin') !== 'true') {
            this.props.router.push('/');
        }
        const { validator } = this.props

        let Mainprops = this.props;
        const { validatorInfo, validatorOffice } = this

        let Mainthis = this;
        return (
            <section className="back-dashboard widget-sidebar-context mt-3" id="my-sidebar-context">

                <div className="container">
                    <div className="row">
                        <Link className="navbar-toggler widget-sidebar-toggler text-white">
                            Sidebar
                        </Link>
                        <Sidebar route={Mainprops.route} />

                        <main className="col-md-9 second-side ps-4 pb-3 h-100">
                            {/* <div className="clearfix"></div> */}

                            <div>
                                <div className="row m-0 bg-white">
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li data-placement="bottom"
                                            title={this.props.t('sidebar.profile_details popop', { param: 'react' })}
                                            className="nav-item">
                                            <a 
                                            aria-label='Ongoing Courses'
                                            className={'nav-link mr-0 active show aftericon'} data-toggle="tab" id="menuTab1"
                                                href="#home"><img className='imgonupap' src="/images/ongoingcourseicon.svg" alt="ongoing" /> Ongoin Course </a>
                                        </li>

                                        <li
                                            data-placement="bottom"
                                            title={this.props.t('jobProviderProfile.reg_office', { param: 'react' })}
                                            className="nav-item">
                                            <a 
                                            aria-label='Upcoming Courses'
                                            className="nav-link mr-0 aftericon" data-toggle="tab" id="menuTab2"
                                                href="#menu2"><img className='imgonupap' src="/images/upcomingcourseicon.svg" alt="upcoming" /> Upcoming Course </a>
                                        </li>
                                        <li data-placement="bottom"
                                            title={this.props.t('jobProviderProfile.unique', { param: 'react' })}
                                            className="nav-item">
                                            <a 
                                            aria-label='Applied Courses'
                                            className="nav-link mr-0 aftericon" data-toggle="tab" id="menuTab3"
                                                href="#menu3"><img className='imgonupap' src="/images/Appliedcourseicon.svg" alt="applied" /> Applied Course </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="clearfix"></div>
                                <div className="tab-content profile-page">
                                    <div id="home" className="tab-pane bg-education active pt-4">

                                        <div className="container">
                                            <div className="row">
                                                <div className="col-md-12 p-0 mx-auto  tab-content border-0 cover-shadow mb-3 my-3  ">
                                                    <div className="panel-heading">
                                                        <h6 className="mb-0"><span >Ongoing Courses</span>
                                                        </h6>
                                                    </div>

                                                    {/* <div className="row mx-0">
                                                        <div className="col-md-4 text-left my-2">
                                                            <label>
                                                                Select District
                                                            </label>
                                                            <select
                                                                className="form-control "

                                                                id="district_id"
                                                                onChange={(event) => this.handleUserInput(event, 'ongoing')}
                                                                name="district_id"
                                                            >
                                                                <option value={""}>
                                                                    {this.props.t("profileDetails.selectDistrict", {
                                                                        param: "react",
                                                                    })}
                                                                </option>
                                                                {this.createDistoption()}
                                                            </select>

                                                        </div>

                                                        <div className="col-md-4 text-left my-2">
                                                            <label>
                                                                {this.props.t("Select Sector", {
                                                                    param: "react",
                                                                })}
                                                               
                                                            </label>
                                                            <select
                                                                className="form-control"
                                                                onChange={(event) => this.handleUserInput(event, 'ongoing')}
                                                                name="sector_id"

                                                            >
                                                                <option value={""}>
                                                                    {this.props.t("Select Sector", {
                                                                        param: "react",
                                                                    })}
                                                                </option>

                                                                {this.props.actionReducer?.sectorsList?.length > 0 &&
                                                                    this.props.actionReducer.sectorsList.map(function (data, index) {
                                                                        return (
                                                                            <option key={index} value={data.id}>
                                                                                {data.name}
                                                                            </option>
                                                                        );
                                                                    })}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4 text-left my-2">
                                                            <label>
                                                                {this.props.t("Select Course", {
                                                                    param: "react",
                                                                })}
                                                             
                                                            </label>
                                                            <select
                                                                className="form-control"
                                                                onChange={(event) => this.handleUserInput(event, 'ongoing')}
                                                                name="course_id"

                                                            >
                                                                <option value={""}>
                                                                    {this.props.t("Select Course", {
                                                                        param: "react",
                                                                    })}
                                                                </option>

                                                                {this.props.actionReducer?.coursesList?.length > 0 &&
                                                                    this.props.actionReducer.coursesList.map(function (data, index) {

                                                                        return (
                                                                            <option key={index} value={data.id}>
                                                                                {data.name}
                                                                            </option>
                                                                        );
                                                                    })}
                                                            </select>
                                                        </div>
                                                    </div> */}
                                                    <div className="panel-body p-policy pt-0  p-3 ">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="table-responsive testable">

                                                                    <table className="table table-striped">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>{this.props.t('dashboard.table.sr_no', { param: 'react' })}</th>
                                                                                <th>District</th>
                                                                                <th style={{ width: '20%' }}>Training Partner</th>
                                                                                <th>Sector</th>
                                                                                <th>Job Role/Trade</th>
                                                                                <th>Batch Code/Id</th>
                                                                                <th>Start Date</th>
                                                                                <th>End Date</th>
                                                                                <th>Batch Strength</th>
                                                                                <th>Training Center</th>

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>

                                                                            {this.props.actionReducer.ongoingCourses && this.props.actionReducer.ongoingCourses.map((d, key) => {
                                                                                return (<tr key={key}>
                                                                                    <td>{key + 1} </td>

                                                                                    <td>{d.district ? d.district : ''}</td>
                                                                                    <td>{d.tp_name ? d.tp_name : ''}</td>
                                                                                    <td>{d.sector ? d.sector : ''}</td>
                                                                                    <td>{d.course ? d.course : ''}</td>
                                                                                    <td>{d.skill_name ? d.skill_name : ''}</td>
                                                                                    <td>{d.start_date}</td>
                                                                                    <td>{d.end_date}</td>
                                                                                    <td>{d.strength ? d.strength + ' candidates' : ''}</td>
                                                                                    <td>{d.tc_name ? d.tc_name : 'N/A'}</td>

                                                                                    {/* <td> {d.applied === "-1" ? <button className='btn btn-primary2 py-1 px-2' onClick={()=>this.applyForCourse(d.start_date , d.end_date , d.id)} >Apply</button>  : "Applied"}</td> */}

                                                                                </tr>)
                                                                            })}

                                                                            {!this?.props?.actionReducer?.ongoingCourses?.length && <tr>
                                                                                <td colSpan="12" style={{ "textAlign": "center" }}><h6>{this.props.t('JobPost.notFound', { param: 'react' })}</h6></td>
                                                                            </tr>}

                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div id="menu2" className="tab-pane bg-education fade pt-4">

                                        <div className="container">
                                            <div className="row">
                                                <div className="col-md-12 p-0 mx-auto  tab-content border-0 cover-shadow   mb-3 mt-3  ">
                                                    <div className="panel-heading">
                                                        <h6 className="mb-0"><span >Upcoming Courses</span>
                                                        </h6>
                                                    </div>
                                                    <div className="row mx-0">
                                                        <div className="col-md-4 text-left my-2">
                                                            <label>
                                                                Select District
                                                            </label>
                                                            <select
                                                                className="form-control "

                                                                id="district_id"
                                                                onChange={(event) => this.handleUserInput(event, 'upcoming')}
                                                                name="district_id"
                                                                aria-label='Select District'
                                                            >
                                                                <option value={""}>
                                                                    {this.props.t("profileDetails.selectDistrict", {
                                                                        param: "react",
                                                                    })}
                                                                </option>
                                                                {this.createDistoption()}
                                                            </select>

                                                        </div>

                                                        <div className="col-md-4 text-left my-2">
                                                            <label>
                                                                {this.props.t("Select Sector", {
                                                                    param: "react",
                                                                })}

                                                            </label>
                                                            <select
                                                                className="form-control"
                                                                onChange={(event) => this.handleUserInput(event, 'upcoming')}
                                                                name="sector_id"
                                                                aria-label="Select Sector"
                                                            >
                                                                <option value={""}>
                                                                    {this.props.t("Select Sector", {
                                                                        param: "react",
                                                                    })}
                                                                </option>

                                                                {this.props.actionReducer?.sectorsList?.length > 0 &&
                                                                    this.props.actionReducer.sectorsList.map(function (data, index) {
                                                                        return (
                                                                            <option key={index} value={data.id}>
                                                                                {data.name}
                                                                            </option>
                                                                        );
                                                                    })}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4 text-left my-2">
                                                            <label>
                                                                {this.props.t("Select Course", {
                                                                    param: "react",
                                                                })}

                                                            </label>
                                                            <select
                                                                className="form-control"
                                                                onChange={(event) => this.handleUserInput(event, 'upcoming')}
                                                                name="course_id"
                                                                aria-label="Select Course"
                                                            >
                                                                <option value={""}>
                                                                    {this.props.t("Select Course", {
                                                                        param: "react",
                                                                    })}
                                                                </option>

                                                                {this.props.actionReducer?.coursesList?.length > 0 &&
                                                                    this.props.actionReducer.coursesList.map(function (data, index) {

                                                                        return (
                                                                            <option key={index} value={data.id}>
                                                                                {data.name}
                                                                            </option>
                                                                        );
                                                                    })}
                                                            </select>
                                                        </div>

                                                        <div className="col-md-4 text-left my-2">
                                                            <label>
                                                                {this.props.t("Select Scheme", {
                                                                    param: "react",
                                                                })}

                                                            </label>
                                                            <select
                                                                className="form-control"
                                                                onChange={(event) => this.handleUserInput(event, 'upcoming')}
                                                                name="shceme_id"
                                                                aria-label="Select Scheme"
                                                            >
                                                                <option value={""}>
                                                                    {this.props.t("Select Scheme", {
                                                                        param: "react",
                                                                    })}
                                                                </option>

                                                                {this.props.actionReducer?.schemesList?.length > 0 &&
                                                                    this.props.actionReducer.schemesList.map(function (data, index) {

                                                                        return (
                                                                            <option key={index + 'scheme'} value={data.scheme_id}>
                                                                                {data.scheme_name}
                                                                            </option>
                                                                        );
                                                                    })}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="panel-body p-policy pt-0  p-3 ">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="table-responsive testable">

                                                                    <table className="table table-striped">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>{this.props.t('dashboard.table.sr_no', { param: 'react' })}</th>
                                                                                <th>District</th>
                                                                                <th style={{ width: '20%' }}>Training Partner</th>
                                                                                <th>Sector</th>
                                                                                <th>Job Role/Trade</th>
                                                                                <th>Batch Code/Id</th>
                                                                                <th>Start Date</th>
                                                                                <th>End Date</th>
                                                                                <th>Batch Strength</th>
                                                                                <th>Training Center</th>
                                                                                <th>Apply</th>

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>

                                                                            {this.props.actionReducer.upcomingCourses && this.props.actionReducer.upcomingCourses.map((d, key) => {
                                                                                return (<tr key={key}>
                                                                                    <td>{key + 1} </td>

                                                                                    <td>{d.district ? d.district : ''}</td>
                                                                                    <td>{d.tp_name ? d.tp_name : ''}</td>
                                                                                    <td>{d.sector ? d.sector : ''}</td>
                                                                                    <td>{d.course ? d.course : ''}</td>
                                                                                    <td>{d.skill_name ? d.skill_name : ''}</td>
                                                                                    <td>{d.start_date}</td>
                                                                                    <td>{d.end_date}</td>
                                                                                    <td>{d.strength ? d.strength + ' candidates' : ''}</td>
                                                                                    <td>{d.tc_name ? d.tc_name : 'N/A'}</td>
                                                                                    <td> {d.applied === "-1" ? <button
                                                                                        aria-label='Apply for this course'
                                                                                        type='button'
                                                                                        className='btn btn-primary2 py-1 px-2' data-target="#applyCourseConfirmationModel" data-toggle="modal" onClick={() => {
                                                                                            // this.applyForCourse(d.start_date, d.end_date, d.id)
                                                                                            this.setState({
                                                                                                start_date: d.start_date,
                                                                                                end_date: d.end_date,
                                                                                                id: d.id
                                                                                            })
                                                                                        }} >Apply</button> : "Applied"}</td>
                                                                                </tr>)
                                                                            })}

                                                                            {!this?.props?.actionReducer?.upcomingCourses?.length && <tr>
                                                                                <td colSpan="12" style={{ "textAlign": "center" }}><h6>{this.props.t('JobPost.notFound', { param: 'react' })}</h6></td>
                                                                            </tr>}

                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div id="menu3" className="tab-pane bg-education fade pt-4">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-md-12 p-0 mx-auto  tab-content border-0 cover-shadow   mb-3 mt-3  ">
                                                    <div className="panel-heading">
                                                        <h6 className="mb-0"><span >Applied Courses</span>
                                                        </h6>
                                                    </div>
                                                    {/* <div className="row mx-0">
                                                        <div className="col-md-4 text-left my-2">
                                                            <label>
                                                                Select District
                                                            </label>
                                                            <select
                                                                className="form-control "

                                                                id="district_id"
                                                                onChange={(event) => this.handleUserInput(event, 'applied')}
                                                                name="district_id"
                                                            >
                                                                <option value={""}>
                                                                    {this.props.t("profileDetails.selectDistrict", {
                                                                        param: "react",
                                                                    })}
                                                                </option>
                                                                {this.createDistoption()}
                                                            </select>

                                                        </div>

                                                        <div className="col-md-4 text-left my-2">
                                                            <label>
                                                                {this.props.t("Select Sector", {
                                                                    param: "react",
                                                                })}
                                                            
                                                            </label>
                                                            <select
                                                                className="form-control"
                                                                onChange={(event) => this.handleUserInput(event, 'applied')}
                                                                name="sector_id"

                                                            >
                                                                <option value={""}>
                                                                    {this.props.t("Select Sector", {
                                                                        param: "react",
                                                                    })}
                                                                </option>

                                                                {this.props.actionReducer?.sectorsList?.length > 0 &&
                                                                    this.props.actionReducer.sectorsList.map(function (data, index) {
                                                                        return (
                                                                            <option key={index} value={data.id}>
                                                                                {data.name}
                                                                            </option>
                                                                        );
                                                                    })}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4 text-left my-2">
                                                            <label>
                                                                {this.props.t("Select Course", {
                                                                    param: "react",
                                                                })}
                                                             
                                                            </label>
                                                            <select
                                                                className="form-control"
                                                                onChange={(event) => this.handleUserInput(event, 'applied')}
                                                                name="course_id"

                                                            >
                                                                <option value={""}>
                                                                    {this.props.t("Select Course", {
                                                                        param: "react",
                                                                    })}
                                                                </option>

                                                                {this.props.actionReducer?.coursesList?.length > 0 &&
                                                                    this.props.actionReducer.coursesList.map(function (data, index) {

                                                                        return (
                                                                            <option key={index} value={data.id}>
                                                                                {data.name}
                                                                            </option>
                                                                        );
                                                                    })}
                                                            </select>
                                                        </div>
                                                    </div> */}
                                                    <div className="panel-body p-policy pt-0  p-3 ">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="table-responsive testable">

                                                                    <table className="table table-striped">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>{this.props.t('dashboard.table.sr_no', { param: 'react' })}</th>
                                                                                <th>District</th>
                                                                                <th style={{ width: '20%' }}>Training Partner</th>
                                                                                <th>Sector</th>
                                                                                <th>Job Role/Trade</th>
                                                                                <th>Batch Code/Id</th>
                                                                                <th>Start Date</th>
                                                                                <th>End Date</th>
                                                                                <th>Batch Strength</th>
                                                                                <th>Training Center</th>
                                                                                <th>Applied Date</th>
                                                                                <th>Apply</th>

                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>

                                                                            {this.props.actionReducer.appliedCourses && this.props.actionReducer.appliedCourses.map((d, key) => {
                                                                                return (<tr key={key}>
                                                                                    <td>{key + 1} </td>

                                                                                    <td>{d.district ? d.district : ''}</td>
                                                                                    <td>{d.tp_name ? d.tp_name : ''}</td>
                                                                                    <td>{d.sector ? d.sector : ''}</td>
                                                                                    <td>{d.course ? d.course : ''}</td>
                                                                                    <td>{d.skill_name ? d.skill_name : ''}</td>
                                                                                    <td>{d.start_date}</td>
                                                                                    <td>{d.end_date}</td>
                                                                                    <td>{d.strength ? d.strength + ' candidates' : ''}</td>
                                                                                    <td>{d.tc_name ? d.tc_name : 'N/A'}</td>
                                                                                    <td>{d.applied_datetime ? d.applied_datetime : ''}</td>
                                                                                    <td><button
                                                                                        aria-label='View Course Details'
                                                                                        type="button" class="btn btn-primary2 py-1 px-2">Applied</button></td>
                                                                                </tr>)
                                                                            })}

                                                                            {!this?.props?.actionReducer?.appliedCourses?.length && <tr>
                                                                                <td colSpan="12" style={{ "textAlign": "center" }}><h6>{this.props.t('JobPost.notFound', { param: 'react' })}</h6></td>
                                                                            </tr>}

                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>



                        </main>


                    </div>
                </div>

                <div className="modal fade" id="applyCourseConfirmationModel" role="dialog" aria-labelledby="applyCourseConfirmationModel" aria-hidden="true" >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header border-bottom-0">

                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close"></button>

                            </div>

                            <div class="modal-body py-0">
                                <p className='fSize18'>Are you sure you want to apply ?</p>
                            </div>

                            <div className="modal-footer border-top-0">
                                <button
                                    aria-label='Yes, apply for this course'
                                    type="button" className="btn btn-success" onClick={() => {
                                        this.applyForCourse(this.state.start_date, this.state.end_date, this.state.id) // Opens in a new tab

                                    }} data-dismiss="modal" >Yes</button>
                                <button
                                    aria-label='No, cancel and go back'
                                    type="button" className="btn btn-danger" data-dismiss="modal">No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = store => {
    return store;
};

export default connect(mapStateToProps)(translate(SkillDevlopment));